import { Box, Paper, Typography } from "@mui/material";
import { useGetCommunications } from "../useCommunicationsQuery";
import columns from "./CommunicationsColumns";
import MaterialReactTable from "material-react-table";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../LoadingComponents";

function CommunicationsList(props) {
  // === web service queries/mutations ===
  const communicationsQuery = useGetCommunications();
  const tableColumns = columns;

  return (
    <>
      {communicationsQuery.isLoading || communicationsQuery.isIdle ? (
        <LoadingPaper />
      ) : communicationsQuery.isError ? (
        <LoadingError error={communicationsQuery.error} />
      ) : (
        communicationsQuery.isSuccess && (
          <Paper
            style={{ minHeight: "fitContent", margin: "3vh", maxWidth: "96%" }}
          >
            {communicationsQuery.data.communications.length === 0 ? (
              <EmptyPaper message={"Nessuna comunicazione"} />
            ) : (
              <MaterialReactTable
                muiTable
                columns={tableColumns}
                data={communicationsQuery.data?.communications || []}
                initialState={{
                  density: "compact",
                }}
                enablePagination={true}
                enableBottomToolbar={true}
                enableTopToolbar={false}
                enableSorting={false}
                muiTablePaperProps={{
                  elevation: 0,
                }}
                muiTableContainerProps={{
                  sx: {
                    overflowX: "hidden",
                  },
                }}
                enableColumnResizing
                enableColumnActions={false}
                enableRowSelection={false}
                renderDetailPanel={({ row }) => {
                  return (
                    <Box
                      sx={{
                        display: "grid",
                        margin: "auto",
                        gridTemplateColumns: "1fr 1fr",
                        width: "100%",
                      }}
                    >
                      <Box sx={{ margin: "10px" }}>
                        <Typography>
                          <strong>Oggetto:</strong>
                          {row.original.subject}
                        </Typography>
                        <Typography>
                          <strong>Contenuto:</strong>
                          {row.original.content}
                        </Typography>
                      </Box>
                      <Box sx={{ margin: "10px" }}>
                        <Typography>
                          <strong>Email utente:</strong>
                          {row.original.user_email}
                        </Typography>
                        <Typography>
                          <strong>Username:</strong>
                          {row.original.user_username}
                        </Typography>
                        <Typography>
                          <strong>Tipo di utente:</strong>
                          {row.original.user_type}
                        </Typography>
                      </Box>
                    </Box>
                  );
                }}
              />
            )}
          </Paper>
        )
      )}
    </>
  );
}

export default CommunicationsList;
